import Cookies from 'js-cookie'
import { cookieName } from '../constants/general'

export const setAccessToken = (token) => {
  localStorage.setItem('isLoggedIn', true)
  return Cookies.set(cookieName, token, { expires: 7 })
}

export const removeAccessToken = () => {
  localStorage.removeItem('isLoggedIn')
  return Cookies.remove(cookieName)
}

export const getAccessToken = () => {
  return Cookies.get(cookieName)
}
